import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription,BehaviorSubject } from 'rxjs';
import { CommonService } from '../../common/common.service';
import { BroadcastService } from '../../infrastructure/broadcaster.service';
import { ConfigService } from '../../infrastructure/config.service';
import { LoaderService } from '../../infrastructure/loader.service';
import { NetworkService } from '../../infrastructure/network.service';
import pdfMake from 'pdfmake/build/pdfmake';
import { MobilePDFVM } from '../../../models/CPP/MobilePDFVM';

@Injectable({
  providedIn: 'root'
})
export class SOTService {
  private subscription = new Array<Subscription>();
  public selectedAccountNo: any;
  public sotRequestId: number;
  isEditMode = false;
  pdfDataObject: any;
  accountToDetails: any = {};
  basePdfData: string;
  filter2: MobilePDFVM = new MobilePDFVM();


  constructor(public broadcastService: BroadcastService,
    public configService: ConfigService,
    public loaderService: LoaderService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private networkService: NetworkService) {
  }

  // Get Account detail data for Account dropdown
  public getFromAccountList() {
    return this.networkService.getRequest(this.configService.getSOTAccountListUrl());
  }

  // Get Deliver to detail data for pickup location dropdown
  public getDeliverToLocationList(accountNumber, shipToAccountParentNumber) {
    const url = this.configService.getSOTDeliverToUrl() + '/' + accountNumber + '/' + shipToAccountParentNumber;
    return this.networkService.getRequest(url);
  }

  // Get Landing page  data
  public getLandingGridList(filters) {
    return this.networkService.postRequest(this.configService.getSOTGridListUrl(), filters);
  }

  public getProductMaster(filters) {
    return this.networkService.postRequest(this.configService.getSOTProductItemsUrl, filters);
  }

  // Get To Account detail data via filter
  public getToccountList(businessName, city, state) {
    return this.networkService.getRequest(this.configService.getSOTToAccountListUrl() + '?businessName=' + businessName + '&city=' + city + '&state=' + state);
  }

  // Save Create Order
  public saveOrder(saveObj) {
    return this.networkService.postRequest(this.configService.sotSaveOrderUrl, saveObj);
  }

  // Save Create Order
  public sotUpdateRequestStatus(saveObj) {
    return this.networkService.postRequest(this.configService.sotUpdateRequestStatusUrl, saveObj);
  }

  setSelectedAccountNo(selectedAccountNo) {
    this.selectedAccountNo = selectedAccountNo;
  }

  getSelectedAccountNo() {
    return this.selectedAccountNo;
  }

  setSOTRequestId(sotRequestId) {
    this.sotRequestId = sotRequestId;
  }

  getSOTRequestId() {
    return this.sotRequestId;
  }

  getEditModeStatus() {
    return this.isEditMode;
  }

  // Get Coi Edit order detail
  public getSOTEditOrderDetail(orderId) {
    return this.networkService.getRequest(this.configService.getSOTEditOrderDetailURLUrl() + '?orderId=' + orderId);
  }

  // Get sot request history detail
  public getSotRequestHistory(requestId) {
    return this.networkService.getRequest(this.configService.getSotRequestHistoryUrl() + '?sotRequestId=' + requestId);
  }

  // Get sot transfer distance
  public getSotTransferDistance(fromAccount, toAccount) {
    return this.networkService.getRequest(this.configService.getSotTransferDistanceUrl() + '?fromAccount=' + fromAccount + '&toAccount=' + toAccount);
  }

  // Get sot configuration list
  public getSotConfigurationList() {
    return this.networkService.getRequest(this.configService.getSotConfigurationListUrl());
  }

  // Get produt line list
  public getProductLineList() {
    return this.networkService.getRequest(this.configService.getProductLine());
  }

  // Get data for landing excel Export
  public getLandingExportData(filters) {
    return this.networkService.postRequest(this.configService.getSOTExprotListUrl(), filters);
  }

  public getItemNumberList() {
    return this.networkService.getRequest(this.configService.getSeedReturnItemNumberData());
  }

  // delete Draft request
  public deleteDraftRequest(requestId) {
    return this.networkService.postRequest(this.configService.deleteSOTDraftRequestDetail(), requestId);
  }

  // //delete Draft request
  // public GetApiDistance() {
  //   return this.networkService.getRequest('https://maps.googleapis.com/maps/api/distancematrix/json?origins=Seattle&destinations=San+Francisco&key=AIzaSyCkUOdZ5y7hMm0yrcCQoCvLwzdM6M8s5qk');
  // }

  // public GetApiDistance() {
  //  return this.networkService.getRequest('api/SOTStockTransfer/get-landing-distance-data');
  // }

  // cancel order request
  public cancelOrderRequest(requestId) {
    return this.networkService.postRequest(this.configService.cancelSotOrderRequestDetail(), requestId);
  }

  // check OTI Orders Exist for Customer PO
  public checkOTIOrders(shipToAccount, customerPO) {
    return this.networkService.getRequest(this.configService.checkSotOTIOrdersForPO() + '?shipToAccount=' + shipToAccount + '&customerPO=' + customerPO);
  }

  // Get Pdf order detail
  public getPdfOrderDetail(sotRequestId) {
    return this.networkService.getRequest(this.configService.getSOTPdfOrderDetailURLUrl() + '?sotRequestId=' + sotRequestId);
  }

  // send SOT Email
  public sendSOTRequestEmail(emailObject) {
    return this.networkService.postRequest(this.configService.sendSotRequestEmail(), emailObject);
  }

  // pdf from base64 date
  public sendBaseDate(filters) {
    return this.networkService.postRequest(this.configService.postFileForSotPdf(), filters);
  }
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  public generatePdf(sotRequestId, isMobile) {
    if (sotRequestId) {
      this.loaderService.setLoaderStatus(true);
      this.getPdfOrderDetail(sotRequestId).subscribe((result) => {
        if (result) {
          if (result !== undefined && result.sotProductList.length > 0) {
            this.pdfDataObject = result;
            const documentDefinition = this.getDocumentDefinition();
            if (isMobile) {
              const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
              pdfDocGenerator.getBase64((data) => {
                this.basePdfData = data;
                this.filter2 = {
                  MobilePDFBase64: this.basePdfData,
                  FileName: 'SOT_' + result.sotrequestNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf'
                };
                this.subscription.push(this.sendBaseDate(this.filter2).subscribe((result) => {

                  this.loaderService.setLoaderStatus(false);
                }, error => this.loaderService.setLoaderStatus(false)));
              });
            } else {
              pdfMake.createPdf(documentDefinition).download('SOT_' + result.sotrequestNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
            }
          } else {
            this.toastrService.error('No data available for RequestNumber #' + result.sotrequestNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      });
    }
  }

  getDocumentDefinition() {
    const orderCreateDate = this.datePipe.transform(this.pdfDataObject.fromRequestDate, 'MMMM dd, yyyy');
    const createDateTime = this.pdfDataObject.createdOnString;
    this.accountToDetails = {};

    if (this.pdfDataObject.toAccountDetail) {
      this.accountToDetails.AccountNumber = this.pdfDataObject.toAccountDetail.accountNumber;
      this.accountToDetails.AccountName = this.pdfDataObject.toAccountDetail.accountName;
      this.accountToDetails.Address1 = this.pdfDataObject.toAccountDetail.address1;
      this.accountToDetails.Address2 = this.pdfDataObject.toAccountDetail.Address2;
      this.accountToDetails.AccountCity = this.pdfDataObject.toAccountDetail.city;
      this.accountToDetails.AccountState = this.pdfDataObject.toAccountDetail.state;
      this.accountToDetails.AccountZipCode = this.pdfDataObject.toAccountDetail.zipCode;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];

    // From Account available
    if (!this.accountToDetails.AccountName && !this.accountToDetails.AccountNumber) {
      displayWith = ['100%'];
      columnList = [{ text: 'FROM: ', bold: true }];
      valueList = [
        'Account#: ' + this.pdfDataObject.fromAccount + ' \n' +
        this.pdfDataObject.fromAccountName + ' \n' +
        this.pdfDataObject.fromAddress1 + ' \n\n' +
        this.pdfDataObject.fromCity + ', ' + this.pdfDataObject.fromState,
      ];
    }
    // From & To  Account available
    else if (this.accountToDetails.AccountName) {
      displayWith = ['48%', '5%', '47%'];
      columnList = [{ text: 'FROM: ', bold: true, style: 'fromToText', }, { text: ' ', bold: true, style: 'emptyHeader', border: [false, false, false, false] }, { text: 'TO: ', bold: true, style: 'fromToText', }];
      valueList = [
        {
          text: [
            'Account#: ',
            { text: this.pdfDataObject.fromAccount + ' \n', style: 'pageText' },
            { text: this.pdfDataObject.fromAccountName + ' \n', style: 'pageText' },
            { text: this.pdfDataObject.fromAddress1 + ' \n\n', style: 'pageText' },
            { text: this.pdfDataObject.fromCity + ', ' + this.pdfDataObject.fromState, style: 'fromToText', marginTop: 5 }]
        },
        { text: ' ', bold: true, style: 'emptyHeader', border: [false, false, false, false] },
        {
          text: [
            'Account#: ',
            { text: this.accountToDetails.AccountNumber + ' \n', style: 'pageText' },
            { text: this.accountToDetails.AccountName + ' \n', style: 'pageText' },
            { text: this.accountToDetails.Address1 + ' \n\n', style: 'pageText' },
            { text: this.accountToDetails.AccountCity + ', ' + this.accountToDetails.AccountState, style: 'fromToText', marginTop: 5 }]
        }
      ];
    }

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: orderCreateDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          style: 'pageText',
          widths: ['25%', '50%', '25%'],
          marginTop: 10,
          fontSize: 8,
          bold: true,
          columns: [{
            image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAlCAYAAACwE5ygAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpjZjgzMmU0Yy1kODcyLTQ3YWQtYmU4NC1mMDc4YTMzYTMwNTgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDEwRjZDNEM3MzAxMTFFOUE0RkRDODkwMzhGMUZGM0QiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDEwRjZDNEI3MzAxMTFFOUE0RkRDODkwMzhGMUZGM0QiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpjZjgzMmU0Yy1kODcyLTQ3YWQtYmU4NC1mMDc4YTMzYTMwNTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Y2Y4MzJlNGMtZDg3Mi00N2FkLWJlODQtZjA3OGEzM2EzMDU4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+NCs+0wAACJ5JREFUeNrsW3lsFFUYf3u05bBUCwUULCglWokU5RARhQJRIeCBCigIMSEgiglWRMAjiMQjeP6l4oWAiHJIRDksp4CAUkWg4AHlaCl35VxaaLd+X/p72a/PmdnZ2nYh2S/5Zd++mfdm5n3392Y89bs9OF8pdaOqoJGEVaoyzSZ0JHgI3xKyjONjCKPRnkcYr6qf+hLeIZTiv8fhXB/hb0IfdQmTn7CV0B//exuMuYbwsPj/NGEioVj0DSS0QntHDd1nU0JaBOenqUucmDGvYbHjCQMI48TxWy3GXCsY0IjQHu09hBloTyJcQQigXUJIFdpWTviYkGsx/wuExoRCwuvoC4jjywiLoRlWxNp0HG2eZwLO/Y3wGfrvI2QSgg5rw/OcIEzGeTcQRqB/A2GOi/UdD6Eqt5i7DM+4RKxnS8Jwwh8eMmXcsZ7QBQdvI/yE9lTCWGPSUYQPhAa9jfaHhMcJXlxU0+WEk4TuhjZyX2e+CWP+cvHrRfsRwhdos/DMdSl4GYQtaOcQOqD9FeZxQ3EwoYMIX6Ivm3Cni7HBMGZXifvh+ZsQdhPW+nHgE8GYTmCMR9z8IkIDQjfCYMGYTmLy+UIaDhCaEU4LqQwYN5MEgWiL85XQPDahf9o8RD9Ckc2xddBOTbK9T7QLRXsFrukVAhEHFIn7Py3GFLhkKj/D9YQz8M/lQlsS4Tv9cAes3T1gsXZrxszAYsfhwd8ltIP5UTAH6WBMVzxEEG29mNlVMKXJEIJ0C8bZ0aOAFTFD90Z4D1nwszVJhRBoK1/IZrk1TOtzhDeUkBJW1U1o98DvleIY+4LNYsJ6WITm+L8kwht9C2ZSgfk/G6bDiUoRfJg4SzhfhUXjSHItnp/xCyS4OsnumXYRHhP/h+qGV3R+KtptwUWmPPweFscz4TNMM+aWzkBltZa1gUPV2udEb0LtTbAgHazCorWG5ncCOgizXhskI9kEGZUpYc5YihsSpggztg6/59DuimhD22/WppUR3owOZ9mBbiTcgkBgPXyPE/1j2Pv/S1OgMT4h3evCjDkX4TXKHI71s5rXbwxeDjWWJ88U7c/BGClRs6qwGOeNkDwXfsaNpNarZollJvxg9CUgePEi9Db9HwtvCpjoMcJgNrWHjPM5FbkKftmH52f/OsyIel+xYgzT94Z9PUZYLf4vIHxkjFlu8bB1jF/TbMYZ4TFryzahpZXU2shZ/BEsusdYHKvrL3URbMwy7mGggx86grBXPkOqEXna+d2vrRZLIU4/Jf6b5Zki4XMUcpDNDoyREuW1WSSFa7Y3wtA6NoyJi4AxXheMcauhXpfnN7Z5Biu6AMEebuaLOsGUlAp4UHMy1bIVHC0f3wmtMqU0A3F6AAkem8nLUJPjRcm3cfINMDYIP7JVmI50LM5uF9InFyYDv4V4Hv2MLYw8x4ri8YzHkSi3gakqd6ikBERS2xbrcMFCYIII7Y9YqroFY2J0kdTKJBd9kIYyG6nwQPp8yB1K0ZcgVD3gIH3xGFOC+WVfsXEfQRf+Q9+rF/dV7iDNeu4SjPHhvoMW8wZdaFONktfID/ajdJHhEObmwxdkicrvXvTno+5jRdMwbi9Mk/Zp3Pe7uJcFMFUaBbinfWgXCqzBmJvE9Q/A/B40cAjoIwqZBRZjDmHuPITvI6KtMS2wyEz1HaReL2qKmKOJOGcAbOoQY2xz5ChJ4rotRJ+W9DtQmXZDKSL6SY7QOSeFuU4yqhtdEJn1RmJc64w5aUQL4RKls6KCWmZEToMRaT1hMX+ZMB8nRFgeh/j+fiyePo/rc2Nw3mwkwn6YnNMWERdXoZ83rEFdLLJHRJFyT0nOG8TYq1EjTEXuxjncA9FgTHXQj5BijqBG4SFHu7yWZuwai0xfM4bLNsvC1KJ8uFaCMNfHlPMmnt28XGrKAZP6w5Tvqm0fIylYxflWIpPX0vgkpE4vsBPZOe1mot3Ixf0OwuLlAtuM3MuK7OY9qirv/fSKhsZIqSu2Of+4TdKn6WYV2hTbiL5XVUXF9mgtPVMA9+ARUdavVRQKnVtF1fnLhW5J2G5xfjubcofpg7h83lNVbEIxZRsVhZqk91TFVnkkdMym/24jiFkcDcZwnUa/eMH78ZNQ3DuKaI0rwVPF+TlhJI/NGu/QfVfLktcLQhBvPGciTDeXmRYaY4bAZNaFWSyH9mcataz90WDMQuQyYxH+vu8wjs3TN2IOnwiJzaLoUBV6SUM6Zx0uaxtvtzeeZBEemyTD+46AHWXgWRNFX2fAjrjq+1K0TBnTs5Coe5BPpBsFSzZJSw2V5pB1HmphVvsyM7EIvWHqLohQexaChYMq9M6YSduhdT5EfVbESeuiMHUsXTubh3Yu5j1vkfn7UMPaiSRzU237mHC1smQs6hnD8ccoynlMkbJ/IyVGUchjYnQRaUxTmC2fcMRsuyPd385EuD09jL2PkUsfk22R2XZRobdX3NJh1Lo8seWtHo3RL4b3FGFtHmpOJcaYBERWPuQnJ0VZ5Aiin/oYV2pERXovJlGF3naMkYOP0RtPKwHWoBNYdP1KLFdo85Gv3I5QuQi/D4nsv0CFXgzXr9G+qCrqZX7kBKcQ6a2KaZczY/KwQAEgB9LNjBiJc4bDFxUiweRMmN8k5M2l2TjnLLRhDxJCXRl+Cj6L+15WFS/88ftk3VXFazwxsmFMHeFrVoik6hmRXfNu3hZoSEOUbqajSqDNYrHI1rmQOQgmKwUJrC6W8h6H3hK4LsYKex+TClN2r3GOzrbnoHQyzCivKPXf14F0/wSYKv0JBb+qo79eS4CZHInsOkY2jNGfCMh3mCfD/LDk90XfGuFLshCFTRRlljQVql2thvNn/7MD2qR3R9nU8cuD/CHUgRgr7E0Zf7+xHT5DQ++Ps7Pmbz3mCgbcBR80DQGA/pBnkxFi87c3f4HJCqZwHEzcBghCWowVlelfAQYAh1IXcqAQJnwAAAAASUVORK5CYII=',
            width: 60,
            height: 20,
            alignment: 'left',
            fit: [100, 100]
          },
          {
            text: orderCreateDate, alignment: 'right', fontSize: 15, style: 'greyText', marginRight: 30
          }]
        },
        {
          style: 'headername',
          table: {
            body: [
              [
                'Stock Transfer ' + '#' + this.pdfDataObject.sotrequestNumber
              ],
            ]
          },
          fontSize: 18,
          layout: 'noBorders',
          marginTop: 10
        },
        {
          text: [
            'Stock Transfer request from ',
            { text: this.pdfDataObject.fromAccountName, bold: true },
            ' to ',
            { text: this.accountToDetails.AccountName, bold: true },
            ' is ',
            { text: this.pdfDataObject.requestStatus == 'SUBMITTED' ? 'PENDING APPROVAL' : (this.pdfDataObject.requestStatus == 'EDITING' ? 'UNDER EDIT' : this.pdfDataObject.requestStatus), bold: true },
            '.'
          ],
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'tableHeader',
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#edeae7' : '#F5F6FA';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#edeae7' : '#edeae7';
            },
          }
        },

        this.getRejectReason(this.pdfDataObject),
        this.getContractPdfObject(this.pdfDataObject),

        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis request ' + '#' + this.pdfDataObject.sotrequestNumber + ' was submitted by ' + this.pdfDataObject.fromAccountName + ' on ' + createDateTime
                + ' (CST). If you have any questions regarding these changes, please contact Winfield United Customer Service #855-494-6343.'],
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? 1 : 1;
            },
            vLineWidth: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? 1 : 1;
            },
            hLineColor: function (i, node) {
              return (i === 0 || i === node.table.body.length) ? '#edeae7' : '#F5F6FA';
            },
            vLineColor: function (i, node) {
              return (i === 0 || i === node.table.widths.length) ? '#edeae7' : '#edeae7';
            },
          },
          border: [true, true, true, true],
          marginTop: 10
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        greyText: {
          color: '#707070',
        },
        fromToText: {
          color: '#505050',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        headername: {
          fontSize: 18,
          bold: true,
          color: '#0b3f54'
        },
        tableHeader: {
          bold: true,
          fillColor: '#F5F6FA',
          fontSize: 8,
          color: '#0b3f54',
          border: [true, true, true, true],
        },
        emptyHeader: {
          bold: true,
          fillColor: '#ffffff',
          fontSize: 8,
          border: [false, false, false, false],
        },
        tableFooter: {
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
      }
    };

    return pdfHTML;
  }

  // Grid display for PDF
  getContractPdfObject(pdfDataObject) {
    const tblObject = [];
    const requestDetails = pdfDataObject.sotProductList;
    const tbl = {
      table: {
        widths: ['50%', '25%', '25%'],
        color: '#0b3f54',
        body: [
          [{
            text: 'Product',
            style: 'tableHeader',
          },
          {
            text: 'Lot#',
            style: 'tableHeader', alignment: 'center'
          },
          {
            text: 'Units',
            style: 'tableHeader', alignment: 'center'
          },
          ],
          ...requestDetails.map(cl => [
            { text: cl.itemDescription },
            { text: cl.lotNumber, alignment: 'center' },
            { text: cl.requestedQty, alignment: 'center' },
          ]),
        ]
      },
      layout: {
        hLineWidth: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? 1 : 1;
        },
        vLineWidth: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
        },
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#edeae7' : '#edeae7';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#edeae7' : '#ffffff';
        },
      },
      border: [true, false, false, true],
      style: 'tablefont',
      marginTop: 10,
    };
    tblObject.push(tbl);

    const tbl4 = {
      layout: 'noBorders',
      table: {
        widths: ['50%', '25%', '25%'],
        color: '#0b3f54',
        body: [
          [{
            text: 'Product Totals:',
            style: 'tableFooter', marginTop: 5,
          },
          {
            text: this.pdfDataObject.productCount + ' Products',
            style: 'tableFooter', marginTop: 5, alignment: 'center'
          },
          {
            text: this.pdfDataObject.unitsSum + ' Bags',
            style: 'tableFooter', marginTop: 5, alignment: 'center'
          }
          ],
        ]
      },
      style: 'tablefont',
      marginTop: 10,
    };
    tblObject.push(tbl4);
    return tblObject;
  }

  getRejectReason(pdfDataObject) {
    if (this.pdfDataObject.requestStatus == 'REJECTED') {
      const tblObject = [];
      const tbl = {
        table: {
          body: [
            [
              'Rejection Reasons'
            ],
          ]
        },
        fontSize: 8,
        color: '#0b3f54',
        bold: true,
        layout: 'noBorders',
        marginTop: 5
      };
      tblObject.push(tbl);

      const tb2 = {
        table: {
          widths: ['100%'],
          heights: 70,
          body: [
            [{
              text: this.pdfDataObject.rejectionComments,
              borderColor: ['#ED4454', '#ED4454', '#ED4454', '#ED4454'],
              color: '#ED4454',
              fontSize: 8,
              bold: true,
            }
            ]
          ]
        },
        marginTop: 5
      };
      tblObject.push(tb2);
      return tblObject;
    }
  }
}
